import { render, staticRenderFns } from "./KycCompliance.vue?vue&type=template&id=c7c66a88&scoped=true"
import script from "./KycCompliance.vue?vue&type=script&lang=js"
export * from "./KycCompliance.vue?vue&type=script&lang=js"
import style0 from "./KycCompliance.vue?vue&type=style&index=0&id=c7c66a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c66a88",
  null
  
)

export default component.exports